// extracted by mini-css-extract-plugin
export default {"band":"LetterSheet_band__vaJYM","bandMobile":"LetterSheet_bandMobile__nNgWe","sheet":"LetterSheet_sheet__oQp5R","desktop":"LetterSheet_desktop__L-m-u"};